/* eslint-disable quotes */
import PaymentPage from '../pages/mobile/payment/PaymentPage.vue';

export default [
  {
    path: "/",
    component: () => import("layouts/App"),
    children: [
      {
        path: "",
        component: () => import("layouts/main/Index"),
        children: [
          {
            path: "",
            name: "login",
            icon: "genderless",
            component: () => import("pages/auth/Index"),
          },
          {
            path: "recover",
            name: "recover",
            icon: "genderless",
            component: () => import("pages/auth/recover-password/Index"),
          },
          {
            path: "company-recover",
            name: "company-recover",
            icon: "genderless",
            component: () => import("pages/auth/company-recover-password/Index"),
          },
          {
            path: "recover/finish",
            name: "recover.finish",
            icon: "genderless",
            component: () => import("pages/auth/recover-password/Recover"),
          },
          {
            path: "company-recover/finish",
            name: "company-recover.finish",
            icon: "genderless",
            component: () => import("pages/auth/company-recover-password/Recover"),
          },
          {
            path: "register",
            name: "register",
            icon: "genderless",
            component: () => import("pages/auth/registration/Index"),
          },
          {
            path: "company-register",
            name: "company-register",
            icon: "genderless",
            component: () => import("pages/auth/company-registration/Index"),
          },
          {
            path: "register/finish",
            name: "register.finish",
            icon: "genderless",
            component: () => import("pages/auth/registration/Finish"),
          },
          {
            path: "company-register/finish",
            name: "company-register.finish",
            icon: "genderless",
            component: () => import("pages/auth/company-registration/Finish"),
          },
          {
            path: "password-reset",
            name: "password-reset",
            icon: "genderless",
            component: () => import("pages/auth/reset-password/Index"),
          },
          {
            path: "privacy-policy",
            name: "privacyPolicy",
            icon: "genderless",
            component: () => import("pages/agreements/privacy-policy/Index"),
          },
          {
            path: "user-agreement",
            name: "userAgreement",
            icon: "genderless",
            component: () => import("pages/agreements/terms-of-use/Index"),
          },          {
            path: "avr-agreement",
            name: "avrAgreement",
            icon: "genderless",
            component: () => import("pages/agreements/avr-agreement/Index"),
          },
          {
            path: "check/:uuid",
            name: "check.index",
            icon: "genderless",
            component: () => import("pages/check/Index"),
          },
          {
            path: "complete/:uuid",
            name: "complete.index",
            icon: "genderless",
            component: () => import("pages/complete/Index"),
          },
        ],
      },
      {
        path: "desktop",
        component: () => import("layouts/admin/Index"),
        children: [
          {
            path: "main",
            name: "desktop.index",
            icon: "genderless",
            component: () => import("pages/desktop/orders/OrdersPage.vue"),
          },
          {
            path: "orders",
            name: "desktop.orders",
            icon: "genderless",
            component: () => import("pages/desktop/orders/OrdersPage"),
          },
          {
            path: "order/:id",
            name: "desktop.order",
            icon: "genderless",
            component: () => import("pages/desktop/orders/OrderPage.vue"),
          },
          {
            path: "new-orders",
            name: "desktop.new-orders",
            icon: "genderless",
            component: () => import("pages/desktop/orders/NewOrdersPage.vue"),
          },
          {
            path: "user/:id",
            name: "desktop.user",
            icon: "genderless",
            component: () => import("pages/desktop/user/Index"),
          },
          {
            path: "users",
            name: "desktop.users",
            icon: "genderless",
            component: () => import("pages/desktop/users/UsersPage"),
          },
          {
            path: "/desktop/limits",
            name: "desktop.limits",
            icon: "genderless",
            component: () => import("pages/desktop/limits/LimitsPage"),
          },
          {
            path: "/desktop/workdays",
            name: "desktop.workdays",
            icon: "genderless",
            component: () => import("pages/desktop/workdays/Index"),
          },
          {
            path: "/desktop/workday-visits",
            name: "desktop.workdayVisits",
            icon: "genderless",
            component: () => import("pages/desktop/workdayVisits/Index"),
          },
          {
            path: '/desktop/filials',
            name: 'desktop.filials',
            icon: 'genderless',
            component: () => import( 'pages/desktop/filials/Index' ),
          },
          {
            path: '/desktop/filial',
            name: 'desktop.filial',
            icon: 'genderless',
            component: () => import( 'pages/desktop/filial/Index' ),
          },
          {
            path: '/desktop/department/:id',
            name: 'desktop.department',
            icon: 'genderless',
            component: () => import( 'pages/desktop/department/Index' ),
          },
          {
            path: "/desktop/profile",
            name: "desktop.profile",
            icon: "genderless",
            component: () => import("pages/desktop/profile/Index"),
          },
          {
            path: "/desktop/support",
            name: "desktop.support",
            icon: "genderless",
            component: () => import("pages/desktop/support/Index"),
          },
          {
            path: "/desktop/eds",
            name: "desktop.eds",
            icon: "genderless",
            component: () => import("pages/desktop/eds/EdsPage"),
          },
          {
            path: "/desktop/eds-documents",
            name: "desktop.eds-documents",
            icon: "genderless",
            component: () => import("pages/desktop/eds-documents/Index"),
          },
          {
            path: 'integration',
            name: 'desktop.integration',
            icon: 'genderless',
            component: () => import('pages/desktop/integration/Index'),
          },
          {
            path: 'reports',
            name: 'desktop.reports',
            icon: 'genderless',
            component: () => import('pages/desktop/reports/ReportsPage'),
          },
          {
            path: "entry-history",
            name: "desktop.entry.history",
            icon: "genderless",
            component: () => import("pages/desktop/entry-history/EntryHistoryDesktop.vue"),
          },
        ],
      },
      {
        path: "mobile",
        component: () => import("layouts/user/Index"),
        children: [
          {
            path: "otp-verify",
            name: "mobile.otp-verify",
            icon: "genderless",
            component: () => import("pages/mobile/otp-verify/OtpVerify.vue"),
          },
          {
            path: "biometric-verify",
            name: "mobile.biometric-verify",
            icon: "genderless",
            component: () => import("pages/mobile/biometric/BiometricPage.vue"),
          },
          {
            path: "transactions",
            name: "mobile.transactions",
            left: "",
            right: "mobile.index",
            icon: "genderless",
            component: () => import("pages/mobile/transactions/Index"),
          },
          {
            path: "main",
            name: "mobile.index",
            left: "mobile.transactions",
            right: "mobile.profile",
            icon: "genderless",
            component: () => import("pages/mobile/orders/Index.vue"),
          },
          {
            path: "orders",
            name: "mobile.orders",
            left: "mobile.orders",
            right: "mobile.orders",
            icon: "genderless",
            component: () => import("pages/mobile/orders/Index.vue"),
          },
          {
            path: "agreement-document",
            name: "mobile.agreement-document",
            icon: "genderless",
            component: () => import('pages/mobile/agreement-document/Index'),
          },
          {
            path: "permanent-otp-document",
            name: "mobile.permanent-otp-document",
            icon: "genderless",
            component: () => import('pages/mobile/permanent-otp-document/Index'),
          },{
            path: "contract-offer",
            name: "mobile.contract-offer",
            icon: "genderless",
            component: () => import('pages/mobile/contract-offer-otp/contract-offer'),
          },
          {
            path: "/mobile/civil-legal-document",
            name: "mobile.civil-legal-document",
            icon: "genderless",
            component: () => import('pages/mobile/civil-legal-document/Index'),
          },
          {
            path: "/mobile/completion-certificate",
            name: "mobile.completion-certificate",
            icon: "genderless",
            component: () => import('pages/mobile/completion-certificate/CompletionCertificate'),
          },
          {
            path: "profile",
            name: "mobile.profile",
            left: "mobile.index",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/profile/Index"),
          },
          {
            path: "profile/my-data",
            name: "mobile.profile.myData",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/my-data/Index"),
          },
          {
            path: "profile/my-documents",
            name: "mobile.profile.myDocuments",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/my-documents/Index"),
          },
          {
            path: "profile/my-cards",
            name: "mobile.profile.myCards",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/my-cards/Index"),
          },
          {
            path: "payment/after",
            name: "mobile.payment.after",
            left: "mobile.profile",
            right: "mobile.index",
            icon: "genderless",
            component: () => import("pages/mobile/after-pay/Index"),
          },
          {
            path: "profile/support",
            name: "mobile.profile.support",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/support/Index"),
          },
          {
            path: "profile/security",
            name: "mobile.profile.security",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/security/Index"),
          },
          {
            path: "profile/support/faqs",
            name: "mobile.profile.support.faqs",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/faqs/Index"),
          },
          {
            path: "profile/notifications",
            name: "mobile.profile.notifications",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/notifications/Index"),
          },

          {
            path: "profile/notifications/:category",
            name: "mobile.profile.notifications.category",
            left: "mobile.profile.notifications",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/notification-page/NotificationPage.vue"),
          },

          {
            path: "profile/contacts",
            name: "mobile.profile.contacts",
            left: "mobile.profile",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/contacts/Index"),
          },
          {
            path: "profile/support/applications",
            name: "mobile.profile.support.applications",
            icon: "genderless",
            component: () => import("pages/mobile/applications/Index"),
          },
          {
            path: "profile/entry-history",
            name: "profile.entry.history",
            icon: "genderless",
            component: () => import("pages/mobile/entry-history/EntryHistory.vue"),
          },
          // time-tracker
          // {
          //   path: "/mobile/time-tracker",
          //   name: "mobile.timeTracker",
          //   left: "mobile.profile",
          //   right: "",
          //   icon: "genderless",
          //   component: () => import("pages/mobile/time-tracker/Index"),
          // },
          {
            path: "/mobile/time-tracker/visits",
            name: "mobile.timeTracker.visits",
            left: "mobile.timeTracker",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/visits/Index"),
          },
          {
            path: "/mobile/time-tracker/visit-confirmations",
            name: "mobile.timeTracker.visitConfirmations",
            left: "mobile.timeTracker",
            right: "",
            icon: "genderless",
            component: () => import("pages/mobile/visit-confirmations/Index"),
          },
        ],
      },
      {
        path: "payment",
        component: () => import("layouts/payment/Index"),
        children: [
          {
            path: "",
            name: "mobile.payment",
            icon: "genderless",
            component: PaymentPage,
          },
          {
            path: "success",
            name: "mobile.payment.success",
            icon: "genderless",
            component: () => import("pages/mobile/modal-success/ModalSuccess.vue"),
          },
        ],
      },
    ],
  },
]
